import { Route, Routes, useParams } from 'react-router-dom'
import { useAppState } from '@/app/hooks/useAppState'
import { useEffect } from 'react'
import ReportsPage from './pages/reports-page'
import ReportView from './pages/report-view'

export default function Reports() {
  const { installationId } = useParams<{ installationId: string }>()
  const { setSelectedInstallationId } = useAppState()

  useEffect(() => {
    if (installationId) {
      setSelectedInstallationId(installationId)
    }
  }, [installationId, setSelectedInstallationId])

  return (
    <Routes>
      <Route path=":periodId" element={<ReportsPage />} />
      <Route path=":periodId/view/:reportId" element={<ReportView />} />
    </Routes>
  )
}
